import SectionHeading from "./SectionHeading";
import { midnightShows } from "@/mocks/home";
import type { MovieDetail } from "../types";

interface MidnightSectionProps {
  onOpen: (movie: MovieDetail) => void;
}

export default function MidnightSection({ onOpen }: MidnightSectionProps) {
  return (
    <section id="midnight" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="03"
          eyebrow="午夜场"
          title="午夜场专场"
          desc="按真正的放映时段排好，从 23:00 一路排到凌晨。几点精神最好，就挑几点的那一场。"
          actionHref="#collections"
          actionLabel="查看深夜片单"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {midnightShows.map((show) => (
            <article
              key={show.id}
              className="flex items-start gap-4 rounded-lg border border-background-300/50 bg-background-100 p-4 transition-colors hover:border-accent-500/40"
            >
              <div className="flex w-16 shrink-0 flex-col items-center rounded-md border border-accent-500/30 bg-accent-500/10 py-2">
                <span className="font-label text-lg leading-none text-accent-300">{show.time}</span>
                <span className="mt-1 text-[10px] text-foreground-500">{show.slot}</span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-display text-base font-bold text-foreground-950">{show.title}</h3>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] text-foreground-500">
                    {show.genre}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{show.summary}</p>
                <button
                  type="button"
                  onClick={() =>
                    onOpen({
                      title: show.title,
                      genre: show.genre,
                      summary: show.summary,
                      tags: [show.slot, show.time],
                    })
                  }
                  className="mt-3 flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-500/40 px-3 py-1.5 text-xs text-primary-200 transition-colors hover:bg-primary-500/15"
                >
                  <i className="ri-play-fill" />
                  进入这一场
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}